<ysh-flow-nav-bar>
  <ysh-button-control type="exit" position="top-left" (click)="didTapDismiss()"/>
</ysh-flow-nav-bar>
<ysh-flow-content>
  <ysh-form
    formHeading="Add Company"
    formCaption="Add a new company to your portal to manage distinct sets of vehicles and drivers. Each company has its own payment method, team invitations, and will be invoiced separately."
    formSubmitLabel="Save Company"
    [formFields]="formFields"
    [onSubmit]="didTapSubmitCompany.bind(this)"
  ></ysh-form>
</ysh-flow-content>
